const Portfolio_data = [
    {
      id: 1,
      category: "DEVELOPMENT",
      totalLike: "600",
      title: "The services provide for design ",
    image: "https://th.bing.com/th/id/OIP.w1yynoiF-ElUt_OUzEIlbwHaE8?pid=ImgDet&rs=1" },
    {
      id: 2,
      category: "APPLICATION",
      totalLike: "750",
      title: "Mobile app landing design & maintain",
      image: "https://raygun.com/blog/wp-content/uploads/2014/06/Anthony-Acosta.jpg"   },
    {
      id: 3,
      category: "PHOTOSHOP",
      totalLike: "630",
      title: "Logo design creativity & Application ",
      image: "https://th.bing.com/th/id/R.67c1b2449691f34a061e3ee4644158ac?rik=nJr8PgGfzd9MwQ&riu=http%3a%2f%2farmando-alexander.com%2fassets%2fimages%2f0618-us-en-android-tablet10-browse-rgb-2000x1250-800x500.png&ehk=%2b1zJOk6jUw6OSLpM3DL0EcqcKE5rw9auFNxqXhMIkHk%3d&risl=&pid=ImgRaw&r=0" },
    {
      id: 4,
      category: "FIGMA",
      totalLike: "360",
      title: "Mobile app landing design & Services",
      image: "https://www.exascaleproject.org/wp-content/uploads/2019/11/Software-Deployment-scaled.jpg",
    },
    {
      id: 5,
      category: "WEB DESIGN",
      totalLike: "280",
      title: "Design for tecnology & services",
      image: "https://blogs.grammatech.com/hs-fs/hubfs/grammatech_agile_development-1.jpg?width=768&height=385&name=grammatech_agile_development-1.jpg",
    },
    {
      id: 6,
      category: "WEB DESIGN",
      totalLike: "690",
      title: "App for tecnology & services",
      image: " https://content.techgig.com/photo/77875593/5-amazing-tensorflow-js-projects-to-kick-start-machine-learning-development-on-web.jpg?149623",
    },
  ]
  export default Portfolio_data